import React from 'react'

import { connect as formikConnect } from 'formik'
import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'
import { PriceDaily } from '../PriceDaily'
import { PriceMonthly } from '../PriceMonthly'
import config from 'SRC/config/config.yaml'

class Container extends React.Component {
  constructor (props) {
    super(props)

    const { formik } = this.props

    this.priceTypes = config.adForm.adPriceTypes

    let rentType = this.priceTypes.dailyMonthly.code

    const priceDaily = formik.values.priceDaily
    const priceMonthly = formik.values.priceMonthly

    if (priceDaily && priceDaily !== -1) {
      rentType = this.priceTypes.daily.code
    }

    if (priceMonthly && priceMonthly !== -1) {
      rentType = this.priceTypes.monthly.code
    }

    if (priceDaily && priceDaily !== -1 && priceMonthly && priceMonthly !== -1) {
      rentType = this.priceTypes.dailyMonthly.code
    }

    this.state = {
      rentType,
      showDailyPrice: rentType === this.priceTypes.dailyMonthly.code || rentType === this.priceTypes.daily.code,
      showMonthlyPrice: rentType === this.priceTypes.dailyMonthly.code || rentType === this.priceTypes.monthly.code
    }
  }

  onRentTypeChange = selectedRentType => {
    const { formik } = this.props
    const { showDailyPrice, showMonthlyPrice } = this.state

    let showDailyPriceUpdated = showDailyPrice
    let showMonthlyPriceUpdated = showMonthlyPrice

    switch (selectedRentType) {
      case this.priceTypes.dailyMonthly.code:
        showDailyPriceUpdated = true
        showMonthlyPriceUpdated = true
        break
      case this.priceTypes.daily.code:
        showDailyPriceUpdated = true
        showMonthlyPriceUpdated = false
        formik.setFieldValue('priceMonthly', -1)
        break
      case this.priceTypes.monthly.code:
        showDailyPriceUpdated = false
        showMonthlyPriceUpdated = true
        formik.setFieldValue('priceDaily', -1)
        break
      default: break
    }

    this.setState({
      showDailyPrice: showDailyPriceUpdated,
      showMonthlyPrice: showMonthlyPriceUpdated,
      rentType: selectedRentType
    })
  }

  renderRentType = () => {
    const { rentType } = this.state

    const options = [
      {
        id: `${this.priceTypes.dailyMonthly.id}`,
        label: this.priceTypes.dailyMonthly.title,
        value: this.priceTypes.dailyMonthly.code,
      },
      {
        id: `${this.priceTypes.daily.id}`,
        label: this.priceTypes.daily.title,
        value: this.priceTypes.daily.code,
      },
      {
        id: `${this.priceTypes.monthly.id}`,
        label: this.priceTypes.monthly.title,
        value: this.priceTypes.monthly.code,
      }
    ]

    return (
      <Wrapper>
				<SelectDropdown
					id='rentPrice'
					title='Period plaćanja'
          isOptional={false}
					isSearchable={false}
					value={rentType}
					options={options}
					onChange={this.onRentTypeChange}
				/>
      </Wrapper>
    )
  }

  render () {
    const { showDailyPrice, showMonthlyPrice } = this.state

    return (
      <React.Fragment>
        {this.renderRentType()}
        {showDailyPrice ? <PriceDaily /> : null}
        {showMonthlyPrice ? <PriceMonthly /> : null}
      </React.Fragment>
    )
  }
}

Container.displayName = 'Rent'

export default formikConnect(Container)
